export const PaymentTypes = [
  { key: "Cash", value: "نقدی" },
  { key: "Credit", value: "اعتباری" },
  { key: "Cheque", value: "چک" },
  //{ key: "Bill", value: "تهاتر" },
  { key: "Trust", value: "امانی" },
];
